import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  getApiUri(): string {
     return environment.apiUrl;
  }
  getStaticUri(): string {
    return environment.staticUrl;

  }
}
